import styled from 'styled-components';

export const Lateral = styled.div`
  background-color: rgb(40 48 68 / 60%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  height: 100%;
  min-width: 100%;
`;

export const ContainModel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TitleVisualMode = styled.h1`
  margin-top: 24px;
  padding: 16px;
  color: #161d1f;
  font-family: 'Lato';
  font-size: 20px;
`;

export const ListUL = styled.ul`
  list-style: disc;
  padding: 12px;
`;
